(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableTextBlurred =  function (){
    if($('[data-text-blurred]').length)
      $('[data-text-blurred]').gnv_textBlurred();
  };

  $.gnv.textBlurred = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$el.data("gnv.textBlurred", base);

    base.words = [];

    base.iterator = 0;

    base.inteval = null;

    base.init = function(){
      base.options = $.extend({},$.gnv.textBlurred.defaultOptions, options);

      base.initArray(false);

      base.inteval = setInterval(base.iterate, base.options.duration);

      $(window).on('resize', function(){
        base.initArray(true);
      });
    };

    base.initArray = function(onlyWidth){
      var liWidth = 0,
          count = base.$el.find('li').length;

      base.$el.find('li:first-child').css('width', 'auto');

      base.$el.find('li').each(function(i){
        var tempWidth = $(this).width();
        if(liWidth < tempWidth)
          liWidth = tempWidth;

        if(i == count - 1) {
          base.$el.find('li:first-child').width(liWidth);
        }

        if(!onlyWidth) {
          base.words[i] = $(this).text();
        }
      });
      if(!onlyWidth) {
        base.$el.append('<li>'+base.words[0]+'</li>');
      }
    }

    base.iterate = function(){

      var li = base.$el.find('li:first-child');
      base.iterator++;
      li.addClass('blurred');
      setTimeout(function(){
        li.text(base.words[base.iterator]);
        li.removeClass('blurred').addClass('unblurred');
        setTimeout(function(){
          li.removeClass('unblurred');
        }, 500);
      }, 500);

      if (base.iterator == base.words.length)
        base.iterator = 0
    }

    base.init();
  };

  $.gnv.textBlurred.defaultOptions = {
    duration: 2500
  };

  $.fn.gnv_textBlurred = function(options){
    return this.each(function(){
      (new $.gnv.textBlurred(this, options));
    });
  };

  $.gnv.enableTextBlurred();

})(jQuery);




